import Main from "../../components/home/main/main";
import About from "../../components/home/about/about";
import styles from "./home.module.scss"
import Solutions from "../../components/home/solutions/solutions";
import HowItWorks from "../../components/home/how-it-works/how-it-works";
import Footer from "../../components/home/footer/footer";


export function HomePage() {
    return (
        <div className={styles.content}>
            <Main/>
            <About/>
            <Solutions/>
            <HowItWorks/>
            <Footer/>
        </div>
    );
}